"use client";

import { Button } from "@artha/ui";
import { useTranslations } from "next-intl";

type FitResultStepProps = {
  onRetry: () => void;
};

export function FitResultStep({
  onRetry,
}: FitResultStepProps) {
  const t = useTranslations("jobDetails.resumeEligibility");
  return (
    <div className="space-y-4">
      <div className="rounded-[12px] border border-[#D0D5DD] bg-white p-4">
        <h3 className="text-base font-bold text-[#344054]">
          {t("unavailableTitle")}
        </h3>
        <p className="mt-1 text-sm text-[#667085]">
          {t("unavailableDescription")}
        </p>
      </div>

      <Button
        type="button"
        className="h-11 w-full rounded-[10px] bg-primary font-bold text-primary-foreground"
        onClick={onRetry}
      >
        {t("retry")}
      </Button>

    </div>
  );
}
